import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JyDashboardService extends BaseService {

  constructor(http:HttpClient){
    super(http);
  }

  getModel():Observable<any>{
    return this.http.get<any>("management/metrics").pipe(
      catchError(this.handleError<any>(`get top menu`))
    );
  }

  getUrl(): string {
    return "";
  }
}

@Injectable({
  providedIn: 'root'
})
export class Metric {
  //内存监控key
  maxMemory:string = "jvm.memory.total.max";
  usedMemory:string = "jvm.memory.total.used";

  //线程监控数据
  threadsCount:string = "jvm.threads.count";
  threadsBlocked:string = "jvm.threads.blocked.count";
  threadsDeadlock:string = "jvm.threads.deadlock.count";

  servletRequest:string = "com.codahale.metrics.servlet.InstrumentedFilter.requests";

  //meters===========
  serverError:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError";//服务器错误监控
  responseCodesBadRequest:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.badRequest";
  responseCodesCreated:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.created";
  responseCodesNoContent:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.noContent";
  responseCodesNotFound:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound";
  responseCodesOk:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok";
  responseCodesOther:string = "com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.other";
  servletErrors:string = "com.codahale.metrics.servlet.InstrumentedFilter.errors";
  timeouts:string = "com.codahale.metrics.servlet.InstrumentedFilter.timeouts";

  maxHeapMemory: string = "jvm.memory.heap.max";
  usedHeapMemory: string = "jvm.memory.heap.used";

  maxCodeCache:string = "jvm.memory.pools.Code-Cache.max";//代码缓存区
  usedCodeCache:string = "jvm.memory.pools.Code-Cache.used";

  maxEdenSpace:string = "jvm.memory.pools.PS-Eden-Space.max";
  usedEdenSpace:string = "jvm.memory.pools.PS-Eden-Space.used";

  maxPsOldGen:string = "jvm.memory.pools.PS-Old-Gen.max";
  usedPsOldGen:string = "jvm.memory.pools.PS-Old-Gen.used";

  maxPsSurvivorSpace:string = "jvm.memory.pools.PS-Survivor-Space.max";
  usedPsSurvivorSpace:string = "jvm.memory.pools.PS-Survivor-Space.used";

  maxCompressedClassSpace:string = "jvm.memory.pools.Compressed-Class-Space.max";
  usedCompressedClassSpace:string = "jvm.memory.pools.Compressed-Class-Space.used";


  //将byte转为m
  getMB(data:number):number{
    return parseFloat((data/(1024*1024)).toFixed(1));
  }



}

